<template>
  <div>
    <h1>{{ tituloh1 }}</h1>
    <div class="my-3">
      <b-card>
        <b-form-group class="mb-4" label-cols-lg="3" label-class="font-weight-bold pt-0" label="Documento a firmar" label-for="file" description="">
          <b-input-group prepend="Fichero" class="mb-2">
            <b-form-file id="file" :ref="'file'" placeholder="Selecciona un fichero en tu equipo" browseText="Buscar" accept=".pdf" v-on:change="handleFileUpload()"></b-form-file>
          </b-input-group>

          <div v-if="indicardescripcion">
            <b-input-group prepend="Descripción" class="mb-2">
              <b-form-input type="text" required placeholder="Descripción del documento a firmar" aria-label="descripcion" v-model="descripcioneditada"></b-form-input>
            </b-input-group>
          </div>
        </b-form-group>
        <div v-if="habilitarSeleccionarTipologia">
          <b-form-group class="mb-4" label-cols-lg="3" label-class="font-weight-bold pt-0" label="Tipo de documento" description="Es muy importante que selecciones bien el tipo de documento para clasificarlo de forma correcta y que sea luego accesible al buscarlo por otras personas">
            <div v-if="modoagrupadopordepartamentos">
              <b-form-select v-model="tipologiaSeleccionada">
                <b-form-select-option :value="null">Selecciona el departamento/tipo de documento</b-form-select-option>
                <b-form-select-option-group v-for="d in optTipologias" :key="d.departamento" :label="d.departamento">
                  <b-form-select-option v-for="t in d.tipologias" :key="t.codigo" :value="t.codigo"> {{ t.descripcion }}</b-form-select-option>
                </b-form-select-option-group>
              </b-form-select>
              <p>
                {{ tipologiaSeleccionada }}: {{ departamentoDeTipoogiaSeleccionada }} -
                {{ descripcionDeTipologiaSeleccionada }}
              </p>
            </div>
            <div v-else>
              <!-- <b-form-select v-model="tipologiaSeleccionada">
              <b-form-select-option :value="null"
                >Selecciona el departamento/tipo de
                documento</b-form-select-option
              >
              <b-form-select-option
                v-for="t in optTipologias"
                :key="t.codigo"
                :value="t.codigo"
                ><strong>{{ t.departamento }}</strong> -
                {{ t.descripcion }}</b-form-select-option
              >
            </b-form-select> -->

              <b-form-radio-group v-model="tipologiaSeleccionada" :options="optTipologias" stacked name="radioTipologiaSeleccionada">
                <!-- <b-form-invalid-feedback :state="state"
                  >Por favor, selecciona una opción</b-form-invalid-feedback
                >
                <b-form-valid-feedback :state="state"
                  >{{ tipologiaSeleccionada }}:
                  {{ departamentoDeTipoogiaSeleccionada }} -
                  {{
                    descripcionDeTipologiaSeleccionada
                  }}</b-form-valid-feedback
                > -->
              </b-form-radio-group>
            </div>
          </b-form-group>
        </div>
      </b-card>
    </div>

    <div class="w-100 d-flex justify-content-between mb-4">
      <b-button :disabled="procesandofichero" @click="pasoatras" variant="danger">
        <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
        Atrás
      </b-button>
      <b-button :disabled="!permitesiguiente" @click="siguientepaso" class="bgcolor-manusa">
        Siguiente
        <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'SubirPDFaFirmar',
  props: {
    tituloh1: {
      type: String,
      default: 'Sube el PDF del contrato que se va a enviar a firmar por via electrónica'
    },
    seccionactiva: {
      type: String,
      default: 'NINGUNA'
    },
    modoagrupadopordepartamentos: {
      type: Boolean,
      default: false
    },
    tipologia: {
      type: String,
      default: ''
    },
    descripcion: {
      type: String,
      default: ''
    },
    seleccionartipologia: {
      type: Boolean,
      default: false
    },
    indicardescripcion: {
      type: Boolean,
      default: false
    },
    tipologiaspredefinidas: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      file: '',
      ficheroseleccionado: false,
      procesandofichero: false,
      descripcioneditada: '',

      // SELECCION DE TIPOLOGIA
      habilitarSeleccionarTipologia: false,
      tipologiaSeleccionada: null,
      optTipologias: [],
      misTipologiasDeEFirma: []
    };
  },
  created() {
    var _t = this;
    setTimeout(() => {
      _t.inicializar();
    }, 1000);
  },
  mounted() {},
  methods: {
    inicializar() {
      // por defecto se toma la información enviada
      this.descripcioneditada = this.descripcion;

      // Preparación de opciones de tipología
      // se clona el objeto para usarlo internamente
      this.misTipologiasDeEFirma = JSON.parse(JSON.stringify(this.$store.getters.misTipologiasDeEFirma));

      if (!this.seleccionartipologia && this.tipologia != '') {
        this.habilitarSeleccionarTipologia = false;
        this.tipologiaSeleccionada = this.tipologia;
        console.log('preseleccion', this.tipologiaSeleccionada);
      } else {
        this.habilitarSeleccionarTipologia = true;
        this.optTipologias = [];
        console.log('misTipologiasDeEFirma', this.misTipologiasDeEFirma);

        if (this.modoagrupadopordepartamentos) {
          this.agruparEnModoDepartamentos();
        } else {
          this.misTipologiasDeEFirma.forEach((it) => {
            if (it.secciones.indexOf(this.seccionactiva) >= 0)
              this.optTipologias.push({
                value: it.codigo,
                html: "<span style='font-weight: 600'>" + it.departamento + '</span> - ' + it.descripcionsimple
              });
          });
        }
        console.log('opt', this.optTipologias);

        if (this.optTipologias.length == 1) {
          this.habilitarSeleccionarTipologia = false;
          this.tipologiaSeleccionada = this.optTipologias[0].value;
        } else {
          if (this.tipologia != '' && this.optTipologias.indexOf(this.tipologia) >= 0) this.tipologiaSeleccionada = this.tipologia;
        }
      }
    },
    agruparEnModoDepartamentos() {
      this.misTipologiasDeEFirma.forEach((it) => {
        if (!this.optTipologias.filter((t) => t.departamento == it.departamento).length)
          this.optTipologias.push({
            departamento: it.departamento,
            tipologias: this.misTipologiasDeEFirma
              .filter((mtdb) => mtdb.departamento == it.departamento && mtdb.secciones.indexOf(this.seccionactiva) >= 0)
              .map((itxd) => {
                return {
                  codigo: itxd.codigo,
                  descripcion: itxd.descripcionsimple
                };
              })
          });
      });
    },
    /**
     * @description: Trigger que se ejecuta cuando se selecciona un nuevo documento, con el fin de extraer el título del documento
     */
    handleFileUpload() {
      this.file = this.$refs.file.$refs.input.files[0];
      this.ficheroseleccionado = true;
      let titulo = this.file.name.split('.')[0];
      if (!this.descripcioneditada.length) this.descripcioneditada = titulo;
    },
    siguientepaso() {
      this.procesandofichero = true;
      //Preparación de los datos
      var _t = this;
      //this.axios.defaults.baseURL = process.env.VUE_APP_API_URL
      var formData = new FormData();
      formData.append('ficherosubidos', this.file);

      this.axios
        .post('/efirma/accion/subir-fichero-temporal/' + this.vuexTokenUsuario, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
            //Authorization: `Bearer ${this.vuexTokenUsuario}`
          }
        })
        .then(function (response) {
          if (response.data.error === '') {
            _t.$emit('pdf-subido', response.data.contenidopdf, _t.tipologiaSeleccionada, _t.descripcioneditada);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          _t.procesandofichero = false;
          // always executed
        });
    },
    pasoatras() {
      this.$emit('paso-atras');
    }
  },
  computed: {
    ...mapGetters({
      vuexTokenUsuario: 'user/token'
    }),
    // state() {
    //   return Boolean(this.tipologiaSeleccionada);
    // },
    permitesiguiente() {
      return this.tipologiaSeleccionada && this.ficheroseleccionado && !this.procesandofichero && (!this.indicardescripcion || (this.indicardescripcion && this.descripcioneditada.length > 0));
    },
    departamentoDeTipoogiaSeleccionada() {
      if (!this.tipologiaSeleccionada) return '';
      return this.misTipologiasDeEFirma.filter((t) => t.codigo == this.tipologiaSeleccionada)[0].departamento;
    },
    descripcionDeTipologiaSeleccionada() {
      if (!this.tipologiaSeleccionada) return '';
      return this.misTipologiasDeEFirma.filter((t) => t.codigo == this.tipologiaSeleccionada)[0].descripcion;
    }
  }
};
</script>
